/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum IssueType {
  Info = 'Info',
  Warning = 'Warning',
  Rejection = 'Rejection',
  Derogation = 'Derogation',
  Default = 'Default'
}
